<ng-template #modalTemplate let-continue="close" let-logout="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@direct-timeout-banner.sessionTimeoutTitle">Renew your session</h2>
  </div>
  <div class="modal-body">
    <p i18n="@@direct-timeout-banner.sessionTimeoutMessage">Please renew your session to keep working in Amadeus Direct. The session will expire in:</p>
    <p class="h3 text-center">{{ 30 - counter }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="logout()" i18n="@@direct-timeout-banner.buttonCancel">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="continue()" i18n="@@direct-timeout-banner.sessionRenewButton">Renew session</button>
  </div>
</ng-template>
